import React, { useState, useRef, useEffect } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import "./thumbnailSlider.css";
import Auditorium1 from '../../../../images/Project_Images/SSSMA-2.webp';
import Auditorium2 from '../../../../images/Project_Images/KIMA_3.webp';
import Auditorium3 from '../../../../images/Project_Images/hdfc2.webp';
// import Auditorium4 from '../../../../images/Project_Images/gcit.webp';
// import Auditorium5 from '../../../../images/Project_Images/farook_clg_2.webp';
// import Auditorium6 from '../../../../images/Project_Images/kalaignar3.webp';
import SSSMA1 from '../../../../images/Project_Images/SSSMA-1.webp';
import SSSMA2 from '../../../../images/Project_Images/SSSMA-2.webp';
import SSSMA3 from '../../../../images/Project_Images/SSSMA-3.webp';
import pso1 from '../../../../images/Project_Images/PSOffice-1.webp';
import pso2 from '../../../../images/Project_Images/PSOffice-2.webp';
import pso3 from '../../../../images/Project_Images/PSOffice-3.webp';
import ssa1 from '../../../../images/Project_Images/ssacademy1.webp';
import ssa2 from '../../../../images/Project_Images/ssacademy2.webp';
import ssa3 from '../../../../images/Project_Images/ssacademy3.webp';
import RIL1 from '../../../../images/Project_Images/ril1.webp';
import RIL2 from '../../../../images/Project_Images/ril2.webp';
import RIL3 from '../../../../images/Project_Images/ril3.webp';
import Anan1 from '../../../../images/Project_Images/anan1.webp';
import Anan2 from '../../../../images/Project_Images/anan2.webp';
import Anan3 from '../../../../images/Project_Images/anan3.webp';
import IBC1 from '../../../../images/Project_Images/IBC-6.webp';
import IBC2 from '../../../../images/Project_Images/IBC-4.webp';
import IBC3 from '../../../../images/Project_Images/IBC-5.webp';
import CollinsAerospace1 from '../../../../images/Project_Images/CollinsAerospace1.webp';
import CollinsAerospace2 from '../../../../images/Project_Images/CollinsAerospace2.webp';
import CollinsAerospace3 from '../../../../images/Project_Images/CollinsAerospace4.webp';
import Samsung1 from '../../../../images/Project_Images/Samsung-1.webp';
import Samsung2 from '../../../../images/Project_Images/Samsung-2.webp';
import Samsung3 from '../../../../images/Project_Images/Samsung-3.webp';
import fiorano1 from '../../../../images/Project_Images/fiorano1.webp';
import fiorano2 from '../../../../images/Project_Images/fiorano_2.webp';
import fiorano3 from '../../../../images/Project_Images/fiorano_3.webp';
import bask_build from '../../../../images/Project_Images/bask_1.webp';
import bask2 from '../../../../images/Project_Images/Bask_2.webp';
import bask3 from '../../../../images/Project_Images/Bask_3.webp';
import minitheater1 from '../../../../images/Project_Images/mini-Theatre-1.webp';
import minitheater2 from '../../../../images/Project_Images/mini-theater-2.webp';
import minitheater3 from '../../../../images/Project_Images/mini-theater-3.webp';
import Meadow1 from '../../../../images/Project_Images/Meadow1.webp';
import Meadow2 from '../../../../images/Project_Images/Meadow2.webp';
import Meadow3 from '../../../../images/Project_Images/Meadow3.webp';
import RO1 from '../../../../images/Project_Images/RoyalOrchid1.webp';
import RO2 from '../../../../images/Project_Images/RoyalOrchid2.webp';
import RO3 from '../../../../images/Project_Images/RoyalOrchid3.webp';
import IATOME1 from '../../../../images/Project_Images/IATOME-electric.webp';
import IATOME2 from '../../../../images/Project_Images/IATOME-electric2.webp';
import IATOME3 from '../../../../images/Project_Images/IATOME-electric3.webp';
import GDMuseum1 from '../../../../images/Project_Images/GdMuseum1.webp';
import GDMuseum2 from '../../../../images/Project_Images/GdMuseum2.webp';
import GDMuseum3 from '../../../../images/Project_Images/GdMuseum3.webp';
import SERENITY1 from '../../../../images/Project_Images/SBH-1.webp';
import SERENITY2 from '../../../../images/Project_Images/SBH-2.webp';
import SERENITY3 from '../../../../images/Project_Images/SBH-3.webp';
import THub1 from '../../../../images/Project_Images/thub_build.webp';
import THub2 from '../../../../images/Project_Images/thub_2.webp';
import THub3 from '../../../../images/Project_Images/thub_3.webp';
import RKMall1 from '../../../../images/Project_Images/RKmall_1.webp';
import RKMall2 from '../../../../images/Project_Images/RKmall_2.webp';
import RKMall3 from '../../../../images/Project_Images/RKmall_3.webp';
import AoL1 from '../../../../images/Project_Images/artofliving_1.webp';
import AoL2 from '../../../../images/Project_Images/artofliving_2.webp';
import AoL3 from '../../../../images/Project_Images/artofliving_3.webp';
import KIMA1 from '../../../../images/Project_Images/KIMA_1.webp';
import KIMA2 from '../../../../images/Project_Images/KIMA_2.webp';
import KIMA3 from '../../../../images/Project_Images/KIMA_3.webp';
const data = {
    Auditorium: [
        {
            id: "aud-1",
            title: "Reliance Industries Ltd",
            location: "Maharashtra",
            // client: "KIMA",
            images: [RIL2, RIL3, RIL1]
        },
        {
            id: "aud-2",
            title: "Shri Sringeri Shankaracharya Matha Auditorium",
            location: "Bangalore",
            // client: "Shri Sringeri Shankaracharya Math",
            images: [SSSMA2, SSSMA3, SSSMA1]
        },
        {
            id: "aud-3",
            title: "Postal Subdivision Office",
            location: "Coimbatore",
            // client: "KIMA",
            images: [pso2, pso3, pso1]
        },
        {
            id: "aud-4",
            title: "Sai Sports Academy",
            location: "Chennai",
            // client: "KIMA",
            images: [ssa2, ssa3, ssa1]
        },
        {
            id: "aud-5",
            title: "Anan International School",
            location: "Coimbatore",
            // client: "KIMA",
            images: [Anan2, Anan3, Anan1]
        },
        {
            id: "aud-6",
            title: "IBC Knowledge Centre",
            location: "Bangalore",
            // client: "KIMA",
            images: [IBC2, IBC3, IBC1]
        },
        {
            id: "aud-7",
            title: "Collins Aerospace",
            location: "Bangalore",
            // client: "KIMA",
            images: [CollinsAerospace2, CollinsAerospace3, CollinsAerospace1]
        },
    ],
    "Recording Studio": [
        {
            id: "rec-1",
            title: "Samsung - R&D",
            location: "Noida",
            client: "Shri Sringeri Shankaracharya Math",
            images: [Samsung3, Samsung2, Samsung1]
        },
        {
            id: "rec-2",
            title: "Fiorano Software Technologies",
            location: "Bangalore",
            client: "Shri Sringeri Shankaracharya Math",
            images: [fiorano2, fiorano3, fiorano1]
        },
        {
            id: "rec-3",
            title: "Bask By Coffee-Restuarant",
            location: "Chennai",
            client: "Shri Sringeri Shankaracharya Math",
            images: [bask2, bask3, bask_build]
        },
        {
            id: "rec-4",
            title: "Honer Aquantis - Mini Theatre",
            location: "Hyderabad",
            client: "Shri Sringeri Shankaracharya Math",
            images: [minitheater2, minitheater3, minitheater1]
        },
        {
            id: "rec-5",
            title: "Meadow",
            location: "Sulur, Coimbatore",
            client: "Shri Sringeri Shankaracharya Math",
            images: [Meadow2, Meadow3, Meadow1]
        },
        {
            id: "rec-6",
            title: "Royal Orchid Resort and Convention Centre",
            location: "Bangalore",
            client: "Shri Sringeri Shankaracharya Math",
            images: [RO2, RO3, RO1]
        },
    ],
    Education: [
        {
            id: "edu-1",
            title: "IATOME",
            location: "Coimbatore",
            client: "Shri Sringeri Shankaracharya Math",
            images: [IATOME2, IATOME3, IATOME1]
        },
        {
            id: "edu-2",
            title: "GD Museum - Experimenta Science Centre",
            location: "Coimbatore, Tamilnadu",
            client: "Shri Sringeri Shankaracharya Math",
            images: [GDMuseum2, GDMuseum3, GDMuseum1]
        },
        {
            id: "edu-3",
            title: "Serenity Banquet Hall",
            location: "Hyderabad",
            client: "Shri Sringeri Shankaracharya Math",
            images: [SERENITY2, SERENITY3, SERENITY1]
        },
        {
            id: "edu-4",
            title: "Technology Hub (T-Hub)",
            location: "Hyderabad",
            client: "Shri Sringeri Shankaracharya Math",
            images: [THub2, THub3, THub1]
        },
        {
            id: "edu-5",
            title: "RK MALL",
            location: "Kasaragod, Kerala",
            client: "Shri Sringeri Shankaracharya Math",
            images: [RKMall2, RKMall3, RKMall1]
        },
        {
            id: "edu-6",
            title: "The Art of Living International Center",
            location: "Bangalore",
            client: "Shri Sringeri Shankaracharya Math",
            images: [AoL2, AoL3, AoL1]
        },
    ],
    Entertainment: [
        {
            id: "ent-1",
            title: "Kings International Medical Academy (KIMA)- Auditorium",
            location: "Chennai",
            client: "Shri Sringeri Shankaracharya Math",
            images: [KIMA2, KIMA3, KIMA1]
        },
    ],
    "Acoustic Wall and Floors": [
        {
            id: "wall-1",
            title: "Shri Sringeri Shankaracharya Matha Auditorium",
            location: "Bangalore",
            client: "Shri Sringeri Shankaracharya Math",
            images: [Auditorium2, Auditorium3, Auditorium1]
        },
    ],
};

function ThumbnailSlider() {
    const mainRef = useRef(null);
    const thumbRef = useRef(null);


    const [activeCategory, setActiveCategory] = useState("Auditorium");
    const [selectedProject, setSelectedProject] = useState(data["Auditorium"][0]);

    const images =
        activeCategory === "All Projects"
            ? Object.entries(data).flatMap(([cat, items]) =>
                items.map(item => ({
                    ...item,
                    uniqueId: cat + "-" + item.id
                }))
            )
            : data[activeCategory].map(item => ({
                ...item,
                uniqueId: activeCategory + "-" + item.id
            }));

    useEffect(() => {
        let list =
            activeCategory === "All Projects"
                ? Object.entries(data).flatMap(([cat, items]) =>
                    items.map(item => ({
                        ...item,
                        uniqueId: cat + "-" + item.id
                    }))
                )
                : data[activeCategory].map(item => ({
                    ...item,
                    uniqueId: activeCategory + "-" + item.id
                }));

        setSelectedProject(list?.[0]);
    }, [activeCategory]);

    useEffect(() => {
        if (mainRef.current) {
            mainRef.current.splide.go(0, true);
        }
    }, [selectedProject]);

    useEffect(() => {
        if (!thumbRef.current || !selectedProject) return;

        const index = images.findIndex(
            (item) => item.uniqueId === selectedProject.uniqueId
        );

        if (index !== -1) {
            thumbRef.current.splide.go(index);
        }
    }, [selectedProject, images]);

    return (

        <div className="container">
            <div className="row">
                <div className="col-12">

                    <div className="thumbnail_slider">

                        {/* 🔥 Category Header */}
                        <div className="slider-header">
                            {[...Object.keys(data), "All Projects"].map((cat) => (
                                <h2
                                    key={cat}
                                    className={activeCategory === cat ? "active" : ""}
                                    onClick={() => setActiveCategory(cat)}
                                >
                                    {cat}
                                </h2>
                            ))}
                        </div>

                        {/* Main Slider */}
                        <Splide key={selectedProject.uniqueId}
                            ref={mainRef}
                            className="main-slider"
                            options={{
                                // type: "loop",
                                rewind: true,
                                perPage: 1,
                                // perMove: 1,
                                arrows: true,
                                pagination: false,
                                speed: 300,
                            }}
                        >
                            {selectedProject?.images.map((img, i) => (
                                <SplideSlide key={i}>
                                    <img src={img} alt="project" />
                                </SplideSlide>
                            ))}
                        </Splide>

                        {/* Thumbnail Slider */}
                        <Splide
                            ref={thumbRef}
                            options={{
                                fixedWidth: 250,
                                gap: 10,
                                pagination: false,
                                arrows: false,
                                focus: "center",
                            }}
                        >
                            {images.map((item, index) => (
                                <SplideSlide key={item.uniqueId}>
                                    <div
                                        className={`thumb-card ${selectedProject?.uniqueId === item.uniqueId ? "active-thumb" : ""
                                            }`}
                                        onClick={() => setSelectedProject(item)}
                                    >
                                        <span className="thumb-serial">
                                            {index + 1}
                                        </span>
                                        <img src={item.images?.[2]} alt={item.title} />

                                        <div className="thumb-content">
                                            <p>{item.title}</p>
                                            <p>{item.location}</p>
                                        </div>
                                    </div>
                                </SplideSlide>
                            ))}
                        </Splide>

                    </div>

                </div>
            </div>
        </div >
    );
}

export default ThumbnailSlider;